<template>
  <div class="select-type">
    <!-- 4-1_投票方法選択 -->
    <hero-animation class="hero-animation" />
    <animation-button class="select-button">
      <div class="buttons appear-anime">
        <div class="btn-outer" @click="goToSeries()"><img class="text" :src="textSelectTitle" :alt="$t('btn001')"></div>
        <div class="btn-outer" @click="goToRandom()"><img class="text" :src="textSelectRandom" :alt="$t('btn002')"></div>
      </div>
    </animation-button>
    <vote-notice />
    <section class="vote-about">
      <BtnAbout />
    </section>
  </div>
</template>

<script>
import HeroAnimation from '@components/global/hero-animation.vue'
import AnimationButton from '@components/global/animation-button.vue'
import BtnAbout from '@components/global/button-about.vue'
import VoteNotice from '@components/global/vote-notice.vue'
import localeVote from '@locales/vote'

export default {
  name: 'select-type',
  $messages: localeVote,
  components: {
    HeroAnimation,
    AnimationButton,
    BtnAbout,
    VoteNotice,
  },
  computed: {
    textSelectTitle() {
      return require(`@images/select-type/${this.$route.params.lang}/btn_select-text-title.png`)
    },
    textSelectRandom() {
      return require(`@images/select-type/${this.$route.params.lang}/btn_select-text-random.png`)
    },
  },
  methods: {
    goToSeries(){
      this.$router.push({path: `/${this.$route.params.lang}/series`, query: {series: 101}})
      window.scrollTo(0, 0)
    },
    goToRandom(){
      this.$router.push(`/${this.$route.params.lang}/random`)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes btnAppear {
  from {
    opacity: 0;
    transform: scale(2, 2);
  }
  to {
    opacity: 1;
    transform: scale(1, 1);
  }
}
.select-type {
  > .hero-animation {
    margin-top: -50px;
  }
  > .select-button {
    margin-top: -90px;
    .buttons {
      position: relative;
      z-index: 3;
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .btn-outer {
      width: 289px;
      height: 291px;
      background-image: url(#{$img-path}select-type/btn_select-base.png);
      background-repeat: no-repeat;
      background-position: 0 50%;
      background-size: 100% auto;
      display: flex;
      align-items: center;
      justify-content: center;
      @include tap-event();
    }
    .appear-anime {
      animation-name: btnAppear;
      animation-duration: 100ms;
      animation-timing-function: ease-in;
      animation-delay: 0ms;
    }
  }
  > .vote-about {
    margin-top: 40px;
  }
}
</style>
